import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Image from 'next/legacy/image';
import { useEffect, useState, useCallback, useMemo } from 'react';
import styled, { css } from 'styled-components';
import HTTPMethod from 'http-method-enum';
import { Modal } from '@poplar/components/Modal';
import { PaginationIndicator } from '@poplar/components/PaginationIndicator';
import { Grid } from '@yoweb/ui/components/Grid';
import { Button } from '@yoweb/ui/components/buttons/Button';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { CaretLeftIcon } from '@yoweb/ui/components/Icon/CaretLeftIcon';
import { CaretRightIcon } from '@yoweb/ui/components/Icon/CaretRightIcon';
import { theme } from '@yoweb/ui/styles';
import { Text, Title } from '@yoweb/ui/components/typography';
import { Box } from '@yoweb/ui/components/Box';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { getSpace } from '@yoweb/ui/styles/utils/theme';
import { URL_FAQ_PAGE } from '@poplar/constants/urls';
import { useUser } from '@poplar/hooks/useUser';
import { API_USER_FINISH_ONBOARDING } from '@poplar/constants/routes';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { RecurringTodoStep } from './RecurringTodoStep';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Step;
/**
 * This modal orients users on new features and navigation updates in the app.
 */

(function (Step) {
  Step["WELCOME"] = "1";
  Step["NEW_TASK"] = "2";
  Step["MANAGE_TASKS"] = "3";
  Step["STAY_CONNECTED"] = "4";
  Step["RECURRING_TODOS"] = "5";
  Step["CHECK_FAQ"] = "6";
})(Step || (Step = {}));

export var EducationModal = function EducationModal() {
  var _profile$onboardingSt, _profile$onboardingSt2;

  var _useUser = useUser(),
      profile = _useUser.profile;

  if (profile !== null && profile !== void 0 && (_profile$onboardingSt = profile.onboardingStatus) !== null && _profile$onboardingSt !== void 0 && _profile$onboardingSt.isPoplarEducationalModalDisplayed && profile !== null && profile !== void 0 && (_profile$onboardingSt2 = profile.onboardingStatus) !== null && _profile$onboardingSt2 !== void 0 && _profile$onboardingSt2.isRecurringTaskModalDisplayed) {
    return undefined;
  }

  return /*#__PURE__*/_jsx(EducationModalInner, {});
};
export var EducationModalInner = function EducationModalInner() {
  var _profile$onboardingSt3;

  var _useUser2 = useUser(),
      isAuthenticated = _useUser2.isAuthenticated,
      profile = _useUser2.profile,
      setUser = _useUser2.actions.setUser;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(Step.WELCOME),
      modalStep = _useState[0],
      setModalStep = _useState[1]; // resolvedModalStep takes into account any features that may cause the
  // regular step order to be changed


  var _useState2 = useState(modalStep),
      resolvedModalStep = _useState2[0],
      setResolvedModalStep = _useState2[1];

  var _useState3 = useState(false),
      isModalOpen = _useState3[0],
      setIsModalOpen = _useState3[1];

  var _useState4 = useState(false),
      isModalDismissed = _useState4[0],
      setIsModalDismissed = _useState4[1];

  var _useExternalConfig = useExternalConfig(),
      _useExternalConfig$gl = _useExternalConfig.globalFeatures,
      enableRecuringTodos = _useExternalConfig$gl.enableRecuringTodos,
      enableGuideDeprecation = _useExternalConfig$gl.enableGuideDeprecation;

  var numOfModalSteps = Object.keys(Step).length - (enableRecuringTodos ? 0 : 1) - (enableGuideDeprecation ? 1 : 0);
  var shouldOpenModal = !isModalDismissed && isAuthenticated && !(profile !== null && profile !== void 0 && (_profile$onboardingSt3 = profile.onboardingStatus) !== null && _profile$onboardingSt3 !== void 0 && _profile$onboardingSt3.isPoplarEducationalModalDisplayed);
  useEffect(function () {
    var currentModalStep = modalStep; // skip the "STAY_CONNECTED" slide if guides are deprecated

    if (enableGuideDeprecation) {
      if (currentModalStep === Step.STAY_CONNECTED) {
        currentModalStep = Step.RECURRING_TODOS;
      } else if (currentModalStep === Step.RECURRING_TODOS) {
        currentModalStep = Step.CHECK_FAQ;
      }
    } // skip the "RECURRING_TODOS" slide if the related feature is not enabled


    if (!enableRecuringTodos && currentModalStep === Step.RECURRING_TODOS) {
      currentModalStep = Step.CHECK_FAQ;
    }

    setResolvedModalStep(currentModalStep);
  }, [modalStep, enableRecuringTodos, enableGuideDeprecation]);
  useEffect(function () {
    if (shouldOpenModal) {
      // need to wait for some time to show the modal, as we have a bug where
      // the page scroll bar doesn't get hidden correctly if this is called too early
      setTimeout(function () {
        return setIsModalOpen(true);
      }, theme.transitionDuration.visual);
    }
  }, [shouldOpenModal]);
  var onModalClose = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchJson(API_USER_FINISH_ONBOARDING, {
              method: HTTPMethod.POST,
              body: JSON.stringify({
                isPoplarEducationalModalDisplayed: true,
                isRecurringTaskModalDisplayed: enableRecuringTodos
              })
            });

          case 2:
            response = _context.sent;

            if (response !== null && response !== void 0 && response.userOnboardingStatus) {
              setUser(function (currentUser) {
                if (currentUser) {
                  return _objectSpread(_objectSpread({}, currentUser), {}, {
                    onboardingStatus: response.userOnboardingStatus
                  });
                }
              });
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [setUser, enableRecuringTodos]);
  var handleDismissModal = useCallback(function () {
    setIsModalDismissed(true);
    setIsModalOpen(false);
    void onModalClose();
  }, [onModalClose]);
  var onNext = useCallback(function () {
    var numModalStep = Number(modalStep);

    if (numModalStep < numOfModalSteps) {
      return setModalStep(String(numModalStep + 1));
    }

    handleDismissModal();
  }, [handleDismissModal, modalStep, numOfModalSteps]);
  var onBack = useCallback(function () {
    var numModalStep = Number(modalStep);

    if (numModalStep > 1) {
      setModalStep(String(numModalStep - 1));
    }
  }, [modalStep]);
  var isFinalStep = useMemo(function () {
    return Number(modalStep) === numOfModalSteps;
  }, [modalStep, numOfModalSteps]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RecurringTodoStep, {
      onModalClose: onModalClose
    }), /*#__PURE__*/_jsx(Modal, {
      isOpen: isModalOpen,
      onClose: function onClose() {
        return handleDismissModal();
      },
      bgColor: getBgColorForStep(resolvedModalStep),
      actionButtons: /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        m: "auto",
        justifyContent: "space-between",
        width: "100%",
        children: [/*#__PURE__*/_jsx(Box, {
          visibility: modalStep !== Step.WELCOME ? 'inherit' : 'hidden',
          children: /*#__PURE__*/_jsx(Button, {
            size: "lg",
            type: "button",
            variant: "tertiary",
            "data-testid": "education-modal-back",
            iconLeft: /*#__PURE__*/_jsx(CaretLeftIcon, {
              size: 16
            }),
            onClick: onBack,
            children: t('actions.back')
          })
        }), /*#__PURE__*/_jsx(PaginationIndicator, {
          steps: numOfModalSteps,
          step: Number(modalStep) - 1,
          onStepChange: function onStepChange(step) {
            return setModalStep(String(step));
          }
        }), /*#__PURE__*/_jsx(Button, {
          size: "lg",
          type: "button",
          variant: "tertiary",
          "data-testid": "education-modal-next",
          iconRight: isFinalStep ? undefined : /*#__PURE__*/_jsx(CaretRightIcon, {
            size: 16
          }),
          onClick: onNext,
          children: t(isFinalStep ? 'actions.done' : 'actions.next')
        })]
      }),
      testId: "education-modal",
      hasCloseButton: true,
      children: /*#__PURE__*/_jsx(EducationModalBody, {
        step: resolvedModalStep
      })
    })]
  });
};
export var EducationModalBody = function EducationModalBody(_ref2) {
  var step = _ref2.step;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var _useIntlMeta = useIntlMeta(),
      language = _useIntlMeta.language,
      country = _useIntlMeta.country;

  var isJapan = country === 'JP';

  var _useExternalConfig2 = useExternalConfig(),
      baseStoreUrl = _useExternalConfig2.baseStoreUrl;

  var _getImageDataForStep = getImageDataForStep(step, language),
      width = _getImageDataForStep.width,
      height = _getImageDataForStep.height,
      imageMarginBottom = _getImageDataForStep.imageMarginBottom,
      isOverflowing = _getImageDataForStep.isOverflowing,
      image = _getImageDataForStep.image;

  return /*#__PURE__*/_jsx(Container, {
    overflowRight: isOverflowing,
    children: /*#__PURE__*/_jsxs(Grid, {
      gap: {
        _: 'small4',
        md: 'medium1'
      },
      children: [/*#__PURE__*/_jsx(Box, {
        display: "flex",
        justifyContent: isOverflowing ? 'flex-end' : 'center',
        mt: isOverflowing ? -70 : undefined,
        mb: imageMarginBottom,
        children: /*#__PURE__*/_jsx(Image, {
          src: image,
          width: width,
          height: height
        })
      }), /*#__PURE__*/_jsxs(Box, {
        textAlign: "center",
        height: 100,
        pr: isOverflowing ? 'normal3' : undefined,
        display: "grid",
        gap: "small3",
        justifySelf: "center",
        children: [/*#__PURE__*/_jsx(Title, {
          size: isJapan ? 'sm' : 'md',
          "data-testid": "education-modal-title",
          whiteSpace: "pre-wrap",
          children: t("education-modal.step".concat(step, ".title"))
        }), /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(Trans, {
            i18nKey: "education-modal.step".concat(step, ".description"),
            components: {
              faq: /*#__PURE__*/_jsx(Text, {
                as: "a",
                href: URL_FAQ_PAGE(baseStoreUrl),
                rel: "noopener noreferrer",
                textDecoration: "underline",
                target: "_blank",
                "data-testid": "education-faq-link"
              })
            }
          })
        })]
      })]
    })
  });
};
export var getBgColorForStep = function getBgColorForStep(step) {
  switch (step) {
    case Step.NEW_TASK:
      return theme.colors.frostLight;

    case Step.MANAGE_TASKS:
      return theme.colors.lilacLight;

    case Step.STAY_CONNECTED:
      return theme.colors.sageLight;

    case Step.RECURRING_TODOS:
      return theme.colors.frostLight;

    default:
      return theme.colors.gingkoLight;
  }
};

var getImageDataForStep = function getImageDataForStep(step, language) {
  switch (step) {
    case Step.WELCOME:
      return {
        width: 232.12,
        height: 325,
        imageMarginBottom: 22,
        image: '/images/education-modal/step1.png'
      };

    case Step.CHECK_FAQ:
      return {
        width: 297,
        height: 325,
        imageMarginBottom: 22,
        image: '/images/education-modal/step6.png'
      };

    default:
      return {
        width: 552,
        height: 417,
        image: "/images/education-modal/".concat(language, "/step").concat(step, ".png"),
        isOverflowing: true
      };
  }
};

var Container = styled.div.withConfig({
  componentId: "sc-148vlsr-0"
})(["padding:", ";position:relative;height:100%;display:flex;flex-direction:column;", ""], getSpace('normal3'), function (_ref3) {
  var overflowRight = _ref3.overflowRight;
  return overflowRight && css(["padding-right:0;"]);
});